// frontend/src/components/Spinner.jsx
import React from "react";
import PropTypes from "prop-types";

/**
 * Spinner — animated SVG ring shown during data-fetch or form submission.
 *
 * @param {{ size?: number, className?: string }} props
 */
function Spinner({ size = 20, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={`animate-spin ${className}`}
      aria-label="Loading"
      role="status"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="3"
        strokeOpacity="0.25"
      />
      <path
        d="M12 2a10 10 0 0 1 10 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

Spinner.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default Spinner;
